import React from 'react'
import { Card, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShield } from '@fortawesome/free-solid-svg-icons'
import InfoRow from './InfoRow'
import { toTitleCase } from '../utils'

const { Title } = Typography

const MedicalAid = ({ recordData, token }) => (
  <Card
    style={{
      marginBottom: '24px',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
    }}
    bodyStyle={{ padding: '20px' }}
  >
    <Title
      level={5}
      style={{
        margin: '0 0 20px 0',
        color: token.colorText,
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}
    >
      <FontAwesomeIcon icon={faShield} style={{ color: token.colorPrimary }} />
      Medical Aid
    </Title>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
      <InfoRow label='Scheme' value={toTitleCase(recordData.patientRecord.medicalAid.name)} token={token} />
      <InfoRow label='Plan' value={toTitleCase(recordData.patientRecord.medicalAid.plan)} token={token} />
      <InfoRow label='Option' value={toTitleCase(recordData.patientRecord.medicalAid.option)} token={token} />
      <InfoRow label='Number' value={recordData.patientRecord.medicalAid.number} token={token} />
      <InfoRow label='Dep Number' value={recordData.patientRecord.medicalAid.dependantNumber} token={token} />
    </div>
  </Card>
)

export default MedicalAid
